const getDefaultState = () => {
    return {
        hasAugment: false,
        augments: {
            '1': {
                exists: false,
                range: '',
                target: '',                
                attack: {
                    isUnique: false,
                    isArea: false,
                    stat: 'Strength',
                    bonusSource: 'weapon',    
                    defense: 'AC',                     
                    staticBonus: '',            
                    weaponNumber: '',
                    hitEffect: '',
                },
                damage: {
                    hasDamage: false,
                    diceQuantity: '1',
                    diceSides: '6',
                    staticBonus: '',
                    addStatMod: true,                
                    type: '',
                },
            },
            '2': {
                exists: false,
                range: '',
                target: '',
                attack: {
                    isUnique: false,
                    isArea: false,
                    stat: 'Strength',
                    bonusSource: 'weapon',    
                    defense: 'AC',                     
                    staticBonus: '',            
                    weaponNumber: '',
                    hitEffect: '',
                },
                damage: {
                    hasDamage: false,
                    diceQuantity: '1',
                    diceSides: '6',
                    staticBonus: '',
                    addStatMod: true,                
                    type: '',
                },                
            },
            '4': {
                exists: false,
                range: '',
                target: '',
                attack: {
                    isUnique: false,
                    isArea: false,
                    stat: 'Strength',
                    bonusSource: 'weapon',    
                    defense: 'AC',                     
                    staticBonus: '',            
                    weaponNumber: '',
                    hitEffect: '',
                },
                damage: {
                    hasDamage: false,
                    diceQuantity: '1',
                    diceSides: '6',
                    staticBonus: '',
                    addStatMod: true,                
                    type: '',
                },                
            },
            '6': {
                exists: false,
                range: '',
                target: '', 
                attack: {
                    isUnique: false,
                    isArea: false,
                    stat: 'Strength',
                    bonusSource: 'weapon',    
                    defense: 'AC',                     
                    staticBonus: '',            
                    weaponNumber: '',
                    hitEffect: '',
                },
                damage: {
                    hasDamage: false,
                    diceQuantity: '1',
                    diceSides: '6',
                    staticBonus: '',
                    addStatMod: true,                
                    type: '',
                },               
            },
        },
    };
};

export default {
    namespaced: true,
    state: getDefaultState(),
    mutations: {     
        resetState: (state) => Object.assign(state, getDefaultState()),    
        setHasAugment: (state, value) => state.hasAugment = value,
        // per augment (general)
        setAugmentExists: (state, { value, index }) => state.augments[index].exists = value, 
        setAugmentRange: (state, { value, index }) => state.augments[index].range = value,
        setAugmentTarget: (state, { value, index }) => state.augments[index].target = value,
        setAugmentHitEffect: (state, { value, index }) => state.augments[index].hitEffect = value,
        // per augment (attack)
        setAugmentAttackIsUnique: (state, { value, index }) => state.augments[index].attack.isUnique = value,
        setAugmentAttackIsArea: (state, { value, index }) => state.augments[index].attack.isArea = value,
        setAugmentAttackStat: (state, { value, index }) => state.augments[index].attack.stat = value,
        setAugmentAttackBonusSource: (state, { value, index }) => state.augments[index].attack.bonusSource = value,
        setAugmentAttackDefense: (state, { value, index }) => state.augments[index].attack.defense = value,
        setAugmentAttackStaticBonus: (state, { value, index }) => state.augments[index].attack.staticBonus = value,
        setAugmentAttackWeaponNumber: (state, { value, index }) => state.augments[index].attack.weaponNumber = value,
        setAugmentAttackHitEffect: (state, { value, index }) => state.augments[index].attack.hitEffect = value,
        // per augment (damage)
        setAugmentDamageHasDamage: (state, { value, index }) => state.augments[index].damage.hasDamage = value,
        setAugmentDamageDiceQuantity: (state, { value, index }) => state.augments[index].damage.diceQuantity = value,
        setAugmentDamageDiceSides: (state, { value, index }) => state.augments[index].damage.diceSides = value,
        setAugmentDamageStaticBonus: (state, { value, index }) => state.augments[index].damage.staticBonus = value,
        setAugmentDamageAddStatMod: (state, { value, index }) => state.augments[index].damage.addStatMod = value,
        setAugmentDamageType: (state, { value, index }) => state.augments[index].damage.type = value,
    },
}